import { StoreState } from "..";

export const getFareOffersWithDetails = (state: StoreState) => state.brandedFares.fareOffersWithDetails;
export const getSelectedFareToken = (state: StoreState) => state.brandedFares.selectedFareToken;
